import { useMemo } from 'react'
import { MapPin } from 'lucide-react'
import { GeoapifyMap, type MapMarker } from '../../shared/components/GoogleMap'
import type { TripPoint } from '../../shared/api/types'

export function LiveMiniMap({ point, userPosition, label }: {
  point: TripPoint | null
  userPosition?: { lat: number; lng: number } | null
  label?: string
}) {
  const userLat = userPosition?.lat
  const userLng = userPosition?.lng
  const markers = useMemo<MapMarker[]>(() => {
    const result: MapMarker[] = []
    if (userLat != null && userLng != null) result.push({ id: 'user', lat: userLat, lng: userLng,
      title: 'Your location', color: '#3B82F6' })
    if (point?.lat != null && point.lng != null)
      result.push({ id: point.id, lat: point.lat, lng: point.lng, title: point.title })
    return result
  }, [point?.id, point?.lat, point?.lng, point?.title, userLat, userLng])
  if (markers.length === 0) return <div className="flex h-28 items-center justify-center gap-2 rounded-st-lg border border-st-line bg-st-surface-2 text-sm text-st-muted">
    <MapPin className="h-4 w-4 shrink-0" /><span>{label ?? 'Location will appear when GPS or the next place is available'}</span></div>
  return <div className="overflow-hidden rounded-st-lg border border-st-line">
    {label && <p className="border-b border-st-line bg-st-surface px-3 py-1.5 text-xs font-medium text-st-muted"><MapPin className="me-1 inline h-3.5 w-3.5" />{label}</p>}
    <GeoapifyMap markers={markers} height="7rem" interactive={false} />
  </div>
}
